(function() {
    angular
        .module("app")
        .controller("EditBeaconScheduleModalController", EditBeaconScheduleModalController)

        EditBeaconScheduleModalController.$inject = [
        "$rootScope",
        "$scope",
        "$uibModalInstance",
        "deviceID",
        "trackerID",
        "schedules",
        "timezoneIANA",
        "onSuccess",
        "onFailure",
        "trackersService"
    ]

    function EditBeaconScheduleModalController(
        $rootScope,
        $scope,
        $uibModalInstance,
        deviceID,
        trackerID,
        schedules,
        timezoneIANA,
        onSuccess,
        onFailure,
        trackersService
    ){
        "use strict"

        $scope.allowSave = false
        $scope.schedule1PM = false
        $scope.schedule2PM = false

        $scope.newSchedules = { ...schedules }

        const oldScheduleComponentValues = {
            start_hour_1:   $rootScope.presentDateTime(schedules.schedule_start_time_1, "TimeHour",   timezoneIANA),
            start_minute_1: $rootScope.presentDateTime(schedules.schedule_start_time_1, "TimeMinute", timezoneIANA),
            start_hour_2:   $rootScope.presentDateTime(schedules.schedule_start_time_2, "TimeHour",   timezoneIANA),
            start_minute_2: $rootScope.presentDateTime(schedules.schedule_start_time_2, "TimeMinute", timezoneIANA),
            end_hour_1:     $rootScope.presentDateTime(schedules.schedule_end_time_1,   "TimeHour",   timezoneIANA),
            end_minute_1:   $rootScope.presentDateTime(schedules.schedule_end_time_1,   "TimeMinute", timezoneIANA),
            end_hour_2:     $rootScope.presentDateTime(schedules.schedule_end_time_2,   "TimeHour",   timezoneIANA),
            end_minute_2:   $rootScope.presentDateTime(schedules.schedule_end_time_2,   "TimeMinute", timezoneIANA)
        }

        $scope.newScheduleComponentValues = { ...oldScheduleComponentValues }

        gtag("event", "create_schedule", { action: "begin", device_id: deviceID })

        const checkNextDays = () => {

            $scope.schedule1NextDay = false
            $scope.schedule2NextDay = false

            const schedule1StartHour = Number($scope.newScheduleComponentValues.start_hour_1)
            const schedule1EndHour   = Number($scope.newScheduleComponentValues.end_hour_1)

            if (schedule1StartHour > schedule1EndHour) {

                $scope.schedule1NextDay = true

            } else if (schedule1StartHour === schedule1EndHour) {

                const schedule1StartMinute = Number($scope.newScheduleComponentValues.start_minute_1)
                const schedule1EndMinute   = Number($scope.newScheduleComponentValues.end_minute_1)

                $scope.schedule1NextDay = schedule1StartMinute >= schedule1EndMinute

            }

            const schedule2StartHour = Number($scope.newScheduleComponentValues.start_hour_2)
            const schedule2EndHour   = Number($scope.newScheduleComponentValues.end_hour_2)

            if (schedule2StartHour > schedule2EndHour) {

                $scope.schedule2NextDay = true

            } else if (schedule2StartHour === schedule2EndHour) {

                const schedule2StartMinute = Number($scope.newScheduleComponentValues.start_minute_2)
                const schedule2EndMinute   = Number($scope.newScheduleComponentValues.end_minute_2)

                $scope.schedule2NextDay = schedule2StartMinute >= schedule2EndMinute

            }

            // Check AM/PM

            $scope.schedule1StartPM = Number($scope.newScheduleComponentValues.start_hour_1) >= 12
            $scope.schedule1EndPM   = Number($scope.newScheduleComponentValues.end_hour_1) >= 12

            $scope.schedule2StartPM = Number($scope.newScheduleComponentValues.start_hour_2) >= 12
            $scope.schedule2EndPM   = Number($scope.newScheduleComponentValues.end_hour_2) >= 12

        }

        $scope.checkFormSave = () => {

            checkNextDays()

            $scope.allowSave = false

            if ($scope.newScheduleComponentValues.start_hour_1 === $scope.newScheduleComponentValues.end_hour_1 && $scope.newScheduleComponentValues.start_minute_1 === $scope.newScheduleComponentValues.end_minute_1) {
                $scope.newScheduleComponentValues.end_minute_1 = ("0" + String(Number($scope.newScheduleComponentValues.end_minute_1) + 5)).slice(-2)
            }

            if ($scope.newScheduleComponentValues.start_hour_2 === $scope.newScheduleComponentValues.end_hour_2 && $scope.newScheduleComponentValues.start_minute_2 === $scope.newScheduleComponentValues.end_minute_2) {
                $scope.newScheduleComponentValues.end_minute_2 = ("0" + String(Number($scope.newScheduleComponentValues.end_minute_2) + 5)).slice(-2)
            }

            for (const key of Object.keys(oldScheduleComponentValues)) {
                const oldValue = oldScheduleComponentValues[key]
                const newValue = $scope.newScheduleComponentValues[key]
                if (oldValue !== newValue) {
                    $scope.allowSave = true
                    return
                }
            }

            if ($scope.newSchedules.schedule_active_1 !== schedules.schedule_active_1) {
                $scope.allowSave = true
                return
            }

            if ($scope.newSchedules.schedule_active_2 !== schedules.schedule_active_2) {
                $scope.allowSave = true
                return
            }
        }

        $scope.toggleSchedule = (scheduleNumber) => {

            if (scheduleNumber === 1) {
                $scope.newSchedules.schedule_active_1 = !$scope.newSchedules.schedule_active_1
            } else {
                $scope.newSchedules.schedule_active_2 = !$scope.newSchedules.schedule_active_2
            }
            $scope.checkFormSave()
        }

        const getNewDateTime = (hour, minute) => {
            const newLocalDateTime = $rootScope.presentDateTime(new Date(), "NumericShortDate") + " " + hour + ":" + minute
            return moment.tz(newLocalDateTime, timezoneIANA).tz("Etc/UTC").format("yyyy-MM-DD HH:mm")
        }

        $scope.saveNewSchedules = () => {

            $scope.newSchedules.schedule_start_time_1 = getNewDateTime($scope.newScheduleComponentValues.start_hour_1, $scope.newScheduleComponentValues.start_minute_1)
            $scope.newSchedules.schedule_start_time_2 = getNewDateTime($scope.newScheduleComponentValues.start_hour_2, $scope.newScheduleComponentValues.start_minute_2)
            $scope.newSchedules.schedule_end_time_1   = getNewDateTime($scope.newScheduleComponentValues.end_hour_1, $scope.newScheduleComponentValues.end_minute_1)
            $scope.newSchedules.schedule_end_time_2   = getNewDateTime($scope.newScheduleComponentValues.end_hour_2, $scope.newScheduleComponentValues.end_minute_2)

            const handleOnSuccess = (data) => {
                if ($scope.newSchedules.schedule_active_1 || $scope.newSchedules.schedule_active_2)
                    gtag("event", "create_schedule", { action: "complete", device_id: deviceID })
                else
                    gtag("event", "delete_schedule", { device_id: deviceID })

                onSuccess(data)
            }

            $uibModalInstance.close(
                trackersService.beaconTrailerEditSchedules(trackerID, $scope.newSchedules, handleOnSuccess, onFailure)
            )
        }

        $scope.cancel = () => {
            gtag("event", "create_schedule", { action: "cancel", device_id: deviceID })
            $uibModalInstance.dismiss("cancel")
        }

        $scope.checkFormSave()

    }
})()
